<template>
  <div class="container material-container">
    <div class="material-desc">
      <img src="../assets/material/material_desc.png">
      <span>{{shareName}}</span>
    </div>
    <div class="material-pic">
      <div class="material-pic-1-wrapper">
        <img src="../assets/family/family_pic_desc_1.png" class="material-pic-1-desc" v-if="pics.length>=1">
        <img :src="pics[0]" class="material-pic-1">
      </div>
      <div class="material-pic-2-wrapper" v-if="pics.length>=2">
        <img src="../assets/family/family_pic_desc_2.png" class="material-pic-2-desc">
        <img :src="pics[1]" class="material-pic-2">
      </div>
    </div>

    <div class="material-btn">
      <img src="../assets/family/family_btn_share.png" class="material-btn-share" @click="doShare"/>
      <img src="../assets/family/family_btn_download.png" class="material-btn-download" @click="downPics"/>
    </div>
    <div class="material-dialog-yl" v-if="dialogVisible" @click="dialogVisible=false"></div>
    <div class="material-dialog" v-if="dialogVisible" @click="dialogVisible=false">
      <div class="material-wrapper">
        <div class="material-text">
          <span>{{ dialogText }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'

export default {

  name: 'Material',
  components: {},
  data() {
    return {
      id: -1,
      type: 1,
      shareName: '课程物料',
      shareCover: null,
      pics: [],
      course: null,
      dialogVisible: false,
      dialogText: '点击右上方按钮转发给朋友吧~'
    }
  },
  computed: {},
  created() {
    this.id = this.$route.params.id;
    if(this.$route.params.type!==undefined && this.$route.params.type!==null){
      this.type = parseInt(this.$route.params.type);
    }
    this.initData();
  },
  methods: {
    initData() {
      if(this.type===1 || this.type==='1'){
        this.getCourseById();
      }else{
        this.getLibraryById();
      }
    },
    getCourseById(){
      let that = this;
      this.$http({
        url: `https://lesson.xiangmayishu.com/api/ms/mscourse/v1/material/${this.id}`,
        // url: `http://8.140.155.165:8888/api/ms/mscourse/v1/material/${that.id}`,
        method: 'get'
      }).then(({data}) => {
        that.pics = data.list;
        that.shareName = data.courseEffect.effectName;
        that.shareCover = data.courseEffect.courseCover;
        document.title = that.shareName;
        that.initShare();
      })
    },
    getLibraryById(){
      let that = this;
      this.$http({
        url: `https://lesson.xiangmayishu.com/api/ms/library/mscourse/v1/material/${this.id}`,
        // url: `http://8.140.155.165:8888/api/ms/library/mscourse/v1/material/${this.id}`,
        method: 'get'
      }).then(({data}) => {
        that.pics = data.list;
        that.shareName = data.libraryCourse.courseName;
        that.shareCover = data.libraryCourse.courseCover;
        document.title = that.shareName;
        that.initShare();
      })
    },
    initShare() {
      let that = this;
      this.initJsSdk(function (res) {
        wx.ready(function () {
          // 分享给好友
          wx.updateAppMessageShareData({
            title: '课程物料', // 分享标题
            desc: that.shareName, // 分享描述
            link: `http://family.xiangmayishu.com/#/material/${that.id}/${that.type}`, // 分享链接
            imgUrl: that.shareCover
          })
          wx.updateTimelineShareData({
            title: '课程物料', // 分享标题
            desc: that.shareName, // 分享描述
            link: `http://family.xiangmayishu.com/#/material/${that.id}/${that.type}`, // 分享链接
            imgUrl: that.shareCover
          })
        })
      });
    },
    initJsSdk(callback) {
      this.$http({
        url: "http://lesson-admin.xiangmayishu.com/admin/wxMp/getWxJsapiSignature",
        method: 'post',
        dataType: 'json',
        contentType: 'application/json;charset=utf-8',
        data: JSON.stringify({url: window.location.href}),
      }).then(({data}) => {
        this.wxConfig(data, callback);
      })
    },
    wxConfig(data, callback) {
      wx.config({
        debug: false,
        appId: data.signature.appId,
        timestamp: data.signature.timestamp,
        nonceStr: data.signature.nonceStr,
        signature: data.signature.signature,
        jsApiList: [ //这里是需要用到的接口名称
          'checkJsApi', //判断当前客户端版本是否支持指定JS接口
          'getLocation', //获取位置
          'openLocation', //打开位置
          'scanQRCode', //扫一扫接口
          'chooseWXPay', //微信支付
          'chooseImage', //拍照或从手机相册中选图接口
          'previewImage', //预览图片接口
          'uploadImage', //上传图片
          'updateAppMessageShareData', //分享给朋友
          'updateTimelineShareData' //分享到朋友圈
        ]
      })
      if (callback) {
        callback(data.signature);
      }
    },
    doShare() {
      if (this.checkWeixin()) {
        this.dialogVisible = !this.dialogVisible;
        this.dialogText = '点击右上方按钮转发给朋友吧~';
      }
    },
    downPics() {
      if (this.checkWeixin()) {
        this.dialogVisible = !this.dialogVisible;
        this.dialogText = '点击右上角选择浏览器打开';
      } else {
        if (this.pics !== null && this.pics.length > 0) {
          for (let i = 0; i < this.pics.length; i++) {
            this.downloadFile(this.pics[i]);
          }
        }
      }

    },
    downloadFile(url) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none"; // 防止影响页面
      iframe.style.height = 0; // 防止影响页面
      iframe.src = url;
      document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
      // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    checkWeixin() {
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_';
    }
  }
}
</script>

<style scoped lang="scss">
.material-container {
  align-items: center;
  height: 100vh;
  background: url("../assets/family/family_bg.png") no-repeat center center;
  background-size: 100% 100%;
  overflow-y: auto;

  .material-desc {
    position: relative;
    width: 702px;
    height: 352px;
    margin-top: 85px;
    img{
      position: absolute;
      width: 702px;
      height: 352px;
    }
    span{
      position: absolute;
      right: 45px;
      font-size: 66px;
      font-family: Source Han Sans CN;
      font-weight: 800;
      color: #353535;
      line-height: 292px;
    }


  }

  .material-pic {
    margin: 392px 0 251px 24px;

    .material-pic-1-wrapper {
      .material-pic-1-desc {
        width: 580px;
        height: 37px;
      }

      .material-pic-1 {
        width: 702px;
        height: 1480px;
        margin-top: 24px;
      }
    }

    .material-pic-2-wrapper {
      margin-top: 40px;

      .material-pic-2-desc {
        width: 580px;
        height: 37px;
      }

      .material-pic-2 {
        width: 702px;
        height: 490px;
        margin-top: 24px;
      }
    }
  }


  .material-btn {
    display: flex;
    position: fixed;
    left: 24px;
    bottom: 90px;

    .material-btn-share {
      width: 332px;
      height: 90px;
    }

    .material-btn-download {
      width: 342px;
      height: 90px;
      margin-left: 28px;
    }
  }
}

.material-dialog-yl {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #000000;
  opacity: 0.3;
}

.material-dialog {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;

  .material-wrapper {
    display: flex;
    margin: 5px 0 0 140px;
    width: 585px;
    height: 172px;
    background: url("../assets/family/family_dialog_bg.png") no-repeat center center;
    background-size: 100% 100%;

    .material-text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 460px;
      height: 80px;
      margin: 87px 0 0 5px;

      span {
        font-size: 28px;
        font-weight: 500;
        color: #252525;
      }
    }
  }


}
</style>
